module.exports = __webpack_public_path__ + "static/media/PCSelectedStarIcon.a6d58d0d.svg";